import { useMutation } from '@tanstack/react-query'
import { FileService } from '../services/FileService'

export default function useMutationUploadLogo() {
	return useMutation({
		mutationFn: (file: File) => FileService.uploadLogo(file),
	})
}
